import Alpine from 'alpinejs';
import { faqs } from './util/faqs';
import { staff } from './util/staff';
import { traitsS01 } from './util/seasonTraits';
import { s01Abi } from './util/s01Abi';
import { fusionAbi } from './util/fusionAbi';
import { checkWeb3 } from './util/checkWeb3';
import { checkWebAccount } from './util/checkWebAccount';
import { updateMyAvime } from './util/updateMyAvime';
import { getRandomIntInclusive } from './util/getRandomIntInclusive';

/**
 * Init Web3
 */

/**
 * Set Alpine.js store data
 */



 console.log(traitsS01);
Alpine.store('fusion', {
  loadCustomTrait(trait) {
    console.log('#trait-' + trait + "-16");
   const file = document.querySelector('#trait-' + trait + "-16").files[0];
   const reader = new FileReader();
   const that = this;

   reader.addEventListener("load", function () {
     // convert image file to base64 string
     console.log(reader.result);
     that.traitsS01[trait][15] = {};
     that.traitsS01[trait][15][that.gender.toLowerCase()] = reader.result;
     that.traits[trait] = 16;
   }, false);

   console.log(file);
   if (file) {
     reader.readAsDataURL(file);
   }
 },

 openTraitInOpenSea(trait){
    let traitNum = this.traits[trait]-1;
    let osQuery = "https://opensea.io/collection/avime-s01?search[sortAscending]=true&search[sortBy]=PRICE&search[stringTraits][0][name]=traitName&search[stringTraits][0][values][0]=";
    console.log(this.traitsS01[trait][traitNum].name);
    if(this.traitsS01[trait][traitNum].name){
      window.open(osQuery+this.traitsS01[trait][traitNum].name, '_blank');
    }

 },

  traitsS01: traitsS01,
  selected: 0,
  gender: 'Female',
  traits: {
    background: 'default',
    body: 'default',
    face: 'default',
    clothes: 'default',
    hair: 'default',
    accessory: 'default',
  },
  clear() {
    this.traits.background = 'default';
    this.traits.body = 'default';
    this.traits.face = 'default';
    this.traits.clothes = 'default';
    this.traits.hair = 'default';
    this.traits.accessory = 'default';
  },
  mint() {
    this.traits.background = getRandomIntInclusive(1, 15);
    this.traits.body = getRandomIntInclusive(1, 15);
    this.traits.face = getRandomIntInclusive(1, 15);
    this.traits.clothes = getRandomIntInclusive(1, 15);
    this.traits.hair = getRandomIntInclusive(1, 15);
    this.traits.accessory = getRandomIntInclusive(1, 15);
  },
  randomize(gender) {
    this.traits.background = getRandomIntInclusive(1, 15);
    this.traits.body = getRandomIntInclusive(1, 15);
    this.traits.face = getRandomIntInclusive(1, 15);
    this.traits.clothes = getRandomIntInclusive(1, 15);
    this.traits.hair = getRandomIntInclusive(1, 15);
    this.traits.accessory = getRandomIntInclusive(1, 15);
    this.gender = (gender === 'Female') ? 'Male' : 'Female';
  },
});

Alpine.store('avime', {
  loaded: false,
  walletConnected: false,
  s00Address: '',
  s01Address: '',
  fusionAddress: '',
  myAvime: [],
  traitName: ['Background', 'Body', 'Face', 'Clothes', 'Hair', 'Accessory'],
  selectedTraits: [0, 0, 0, 0, 0, 0],
  selectedSeasons: [-1, -1, -1, -1, -1, -1],
  cardCurrent: null,
  cardData: [],
  nameData: [],
  descData: [],
  thumbData: [],
  maleData: [],
  femaleData: [],
  currentTraitNum: null,
  s00Contact: null,
  s01Contract: null,
  fusionContact: null,
  walletAddress: '',
  checkWeb3: '',
  checkWebAccount: '',
  updateMyAvime: updateMyAvime,
  T0_current: null,
  T0_data: [],
  staff: staff,
  faqs: faqs,
  season0Data: null,
  fusion: {
    selected: {
      count: 6,
      gender: 'Female',
      traits: {
        background: 'default',
        body: 'default',
        face: 'default',
        clothes: 'default',
        hair: 'default',
        accessory: 'default',
      },
    },
  },
  complete() {
    this.loaded = true;

  },
  connect() {
    this.walletConnected = true;
  },
  disconnect() {
    this.walletConnected = false;
  },
});

/**
 * Init Alpine.js
 */
window.Alpine = Alpine;
Alpine.start();

/**
 * Init everything else...
 */
document.addEventListener('DOMContentLoaded', () => {
  window.Alpine.store('avime').complete();

});
